<script>
import Moment from 'moment-timezone';
import _ from 'lodash';
import { extendMoment } from 'moment-range';
import EventBus from '../EventBus.js';
import Spinner from './Spinner.vue';

const moment = extendMoment(Moment);
moment.tz.setDefault("America/Los_Angeles");
export default {
  components: { Spinner },
  props: ['inputStartTime'],
  data: function() {
    return {
      events: [],
      startTime: this.getStartTime(),
      endTime: this.getEndTime(),
      selectedIndex: [],
      moveRightCount: 0,
      loading: false,
    }
  },
  methods: {
    getInitialSelectedIndex() {
      if (this.inputStartTime) {
        var selected = moment(this.inputStartTime);
        var start = moment(this.inputStartTime).set('hour', 15).set('minute', 0).set('second', 0);
        var duration = moment.duration(selected.diff(start));
        var minutes = duration.asMinutes();
        return [_.findIndex(this.daysList, (day) => { return selected.isSame(day.object, 'day') }), minutes / 30];
      } else {
        return []
      }
    },
    loadEvent: function() {
      this.loading = true;
      return this.$getGoogleCalendarEvents(
        this.startTime.format(),
        moment(this.endTime).add(2, 'h').add(30, 'minutes').format(),
        this.assignEvents
      );
    },
    assignEvents: function(data) {
      this.events = _.map(data.items, function(item) {
        var start = moment(item.start.dateTime);
        var end = moment(item.end.dateTime);
        var range = moment.range(start, end);
        return { start, end, range };
      });
    },
    // 3pm of nearest feature Tuesday or Thurday
    getStartTime: function() {
      var ThursdayIndex = 4;
      var TuesdayIndex = 2;
      var today = moment(this.inputStartTime);
      var todayIndex = today.isoWeekday();
      var result;
      if (this.inputStartTime) {
        result = today;
      } else if (todayIndex >= ThursdayIndex) {
        result = today.isoWeekday(TuesdayIndex).add(7, 'd');
      } else if(todayIndex < ThursdayIndex && todayIndex >= TuesdayIndex) {
        result = today.isoWeekday(ThursdayIndex);
      } else {
        result = today.isoWeekday(TuesdayIndex);
      }
      return result.set('hour', 15).set('minute', 0).set('second', 0);
    },
    getEndTime: function(startTime) {
      startTime = moment(startTime || this.getStartTime());
      if(startTime.isoWeekday() == 2) {
        return startTime.add(2, 'd');
      } else {
        return startTime.add(5, 'd');
      }
    },
    timeClass: function(index, day) {
      var klass = ['slot', 'text-center'];
      day.busySlots.indexOf(index) == -1 ? klass.push('active') : klass.push('busy')
      if (this.selectedIndex[0] == this.daysList.indexOf(day) && this.selectedIndex[1] == index) klass.push('selected')
      return klass;
    },
    moveLeft: function() {
      if (!this.canMoveLeft || this.loading) return;
      this.startTime = moment(this.startTime.subtract(7, 'd'))
      this.endTime = this.getEndTime(this.startTime);
      this.loadEvent();
      this.moveRightCount = this.moveRightCount - 1;
      this.resetSlectedTime();
    },
    moveRight: function() {
      if (this.loading) return;
      this.startTime = moment(this.startTime.add(7, 'd'))
      this.endTime = this.getEndTime(this.startTime);
      this.loadEvent();
      this.moveRightCount = this.moveRightCount + 1;
      this.resetSlectedTime();
    },
    onTimeSelect: function(day, slotIndex) {
      if(day.busySlots.indexOf(slotIndex) > -1) return
      this.$emit('time-select', moment(day.object).add(slotIndex * 30, 'minutes'), 'mobile');
      this.selectedIndex = [this.daysList.indexOf(day), slotIndex];
    },
    resetSlectedTime() {
      this.$emit('time-select', null);
      this.selectedIndex = [];
    },
    stopLoading() {
      this.loading = false
    },
  },
  computed: {
    daysList: function() {
      var theDate = moment(this.startTime);
      var count = 0;
      var days = [];
      //  we only display 2 days for mobile
      while (count < 2) {
        // loop through events to check busy slots
        var busySlots = [];
        _.each(this.events, function(event) {
          var range1 = moment.range(theDate, moment(theDate).add(29, 'minutes'));
          var range2 = moment.range(moment(theDate).add(30, 'minutes'), moment(theDate).add(59, 'minutes'));
          var range3 = moment.range(moment(theDate).add(60, 'minutes'), moment(theDate).add(89, 'minutes'));
          var range4 = moment.range(moment(theDate).add(90, 'minutes'), moment(theDate).add(119, 'minutes'));
          if (event.range.overlaps(range1)) {
            busySlots.push(0);
          }
          if (event.range.overlaps(range2)) {
            busySlots.push(1);
          }
          if (event.range.overlaps(range3)) {
            busySlots.push(2);
          }
          if (event.range.overlaps(range4)) {
            busySlots.push(3);
          }
        });

        days.push({ object: moment(theDate), busySlots });

        count = count + 1;
        if (theDate.isoWeekday() == 2) {
          theDate.add(2, 'd');
        } else {
          theDate.add(5, 'd')
        }
      }

      return days;
    },
    canMoveLeft: function() {
      return this.moveRightCount > 0;
    }
  },
  mounted() {
    this.loadEvent();
    this.selectedIndex = this.getInitialSelectedIndex();
  },
  created() {
    EventBus.$on('google-api-finish-loading', this.stopLoading)
  },
  beforeDestroy() {
    EventBus.$off('google-api-finish-loading', this.stopLoading)
  }
}

</script>

<template>
  <div class="calendar-container">
    <div class="flex-box horizontally-centered">
      <div>
        <div class="gap-3x"></div>
        <div
          :class="['controller', canMoveLeft ? '' : 'inactive']"
          @click="moveLeft"
        ><font-awesome-icon icon="chevron-left" /></div>
      </div>
      <div class="spinner-container flex-box" v-if="loading"><Spinner /></div>
      <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
      <div v-for="day in daysList" :key="day.object.format()" class="day" v-if="!loading">
        <div class="gap-3x"></div>
        <div class="bold text-center day-label">{{day.object.format('dddd')}}</div>
        <div class="bold text-center day-label">{{day.object.format('MMMM D')}}</div>
        <div class="gap-3x"></div>
        <div :class="timeClass(0, day)" @click="() => onTimeSelect(day, 0)">3:00 PM</div>
        <div :class="timeClass(1, day)" @click="() => onTimeSelect(day, 1)">3:30 PM</div>
        <div :class="timeClass(2, day)" @click="() => onTimeSelect(day, 2)">4:00 PM</div>
        <div :class="timeClass(3, day)" @click="() => onTimeSelect(day, 3)">4:30 PM</div>
      </div>
      <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
      <div>
        <div class="gap-3x"></div>
        <div
          class="controller"
          @click="moveRight"
        ><font-awesome-icon icon="chevron-right" /></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .spinner-container {
    width: 264px;
  }
</style>
